import {useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useWindowSize} from "../../../../../../hook/useWindowSize";
import {useMySearchParams} from "../../../../../../hook/useMySearchParams";
import {useGetPatientAllergies} from "../../../../../../hook/request/ehr/patientAllergy";
import {general} from "../../../../../../store/action";
import {connect, useSelector} from "react-redux";
import AddPatientAllergyModal from "../../allergy/addPatientAllergyModal";
import EmptyBox from "../../../../general/emptyBox";
import PatientAllergySummaryRowItem from "./dataList/patientAllergySummary_rowItem";
import {TDataList} from "../../../../../../types/general";
import {useFindAccessInAccessList} from "../../../../../../constants/constant/accessProcess";

type TFilterValues = {
  patient?: string;
  pageNumber?: string;
  perPage?: string;
  search?: string;
}

type patientAllergySummaryProps = {
  patientData?: any;
  openTab?: string;
  handleShowModal: any;
  visitEHRCheck?: boolean;
}

const PatientAllergySummary = ({
 patientData,
 openTab,
 handleShowModal,
 visitEHRCheck = false,
}: patientAllergySummaryProps) => {

  const isProvider = useSelector((state: any) => state.general.userDataReducer.isProvider);
  const {findAccessInAccessList} = useFindAccessInAccessList();
  const [width] = useWindowSize();
  const [searchParams] = useSearchParams();
  const { getQueryParams, updateSearchParams } = useMySearchParams();
  const [allergiesData, setAllergiesData] = useState<TDataList>({
    data: [],
    count: 0
  });
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    patient: patientData ? patientData : '0',
    pageNumber: "0",
    perPage: "3",
    search: "",
  });

  // services
  const getAllergiesRequest = useGetPatientAllergies(getQueryParams(filterValues), openTab === 'patientSummary' && filterValues?.patient !== '0');

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      patient: patientData,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "3",
      search: searchParams.get("search") || "",
    }
    setFilterValues(_filterValues)
  }, [searchParams, patientData]);

  useEffect(() => {
    getAllergiesRequest?.data?.data?.result &&
    setAllergiesData(getAllergiesRequest?.data?.data.result)
  }, [getAllergiesRequest.data])

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    updateSearchParams({
      pageNumber: "0",
      perPage: filterValues?.perPage,
      [name]: value,
    })
  }

  const _dataList = allergiesData?.data && allergiesData?.data?.length > 0 && allergiesData?.data?.map((item: any, i: number) => {
    return(
      <div className={`py-3 ${(i + 1) !== allergiesData?.data?.length ? 'border-bottom' : ''}`}>
        <PatientAllergySummaryRowItem key={i} item={item}/>
      </div>
    )
  });

  return (
    <>
      <div className="rounded">
        <section className=" d-flex flex-column align-items-center flex-md-row border-bottom">
          <div className="form-group ms-md-auto fw-bold mx-3 my-2">
            حساسیت ها
          </div>
          {((visitEHRCheck && isProvider) || findAccessInAccessList('EHR_ALLERGY_CREATE')) &&
            <a className='p-1 d-flex align-items-center btn btn-dark rounded rounded-3 mx-3 my-2'
              onClick={() => handleShowModal('addPatientAllergyModal', {
                patientId: patientData,
                patientData: patientData
              })}>
              <span className="m-1">افزودن حساسیت</span>
            </a>
          }
        </section>
        <section className="mx-3 my-2">
          {
            allergiesData?.data?.length === 0 ? <EmptyBox/> : _dataList
          }
        </section>
      </div>
      {openTab === 'patientSummary' && <AddPatientAllergyModal/>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PatientAllergySummary);
